var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedSix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3348_15986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11C2.5 5.75329 6.75329 1.5 12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.75329 48.5 2.5 44.2467 2.5 39V11Z",
    stroke: "#2563EB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18 22.6744C18 18.436 21.3579 15 25.5 15C29.6421 15 33 18.436 33 22.6744C33 24.9468 32.034 26.9892 30.5014 28.3934C29.9906 28.8614 29.6122 29.2082 29.344 29.4598C29.2099 29.5855 29.1074 29.6838 29.0317 29.7592C28.994 29.7968 28.9651 29.8266 28.9436 29.8496C28.933 29.861 28.925 29.8699 28.9192 29.8766C28.9133 29.8834 28.9108 29.8864 28.9108 29.8864C28.6743 30.1851 28.6231 30.2622 28.5926 30.332C28.5621 30.4018 28.5402 30.4922 28.4805 30.8717C28.457 31.0216 28.4545 31.2782 28.4545 31.9767V32.0067C28.4546 32.4158 28.4546 32.7687 28.4289 33.0583C28.4018 33.3645 28.3418 33.6677 28.1805 33.9535C28.001 34.2717 27.7428 34.5359 27.4318 34.7196C27.1525 34.8846 26.8562 34.946 26.557 34.9738C26.274 35 25.9292 35 25.5294 35H25.5293H25.4707H25.4706C25.0708 35 24.726 35 24.443 34.9738C24.1438 34.946 23.8475 34.8846 23.5682 34.7196C23.2572 34.5359 22.999 34.2717 22.8195 33.9535C22.6582 33.6677 22.5982 33.3645 22.5711 33.0583C22.5454 32.7687 22.5454 32.4158 22.5455 32.0067L22.5455 31.9767C22.5455 31.2782 22.543 31.0216 22.5195 30.8717C22.4598 30.4922 22.4379 30.4018 22.4074 30.332C22.3769 30.2622 22.3257 30.1851 22.0892 29.8864C22.0892 29.8864 22.0865 29.8831 22.0808 29.8766C22.075 29.8699 22.067 29.861 22.0564 29.8496C22.0349 29.8266 22.006 29.7968 21.9683 29.7592C21.8926 29.6838 21.7901 29.5855 21.656 29.4598C21.3878 29.2082 21.0094 28.8614 20.4986 28.3934C18.966 26.9892 18 24.9468 18 22.6744Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0852 32.6748H23.9151C23.9181 32.7718 23.9226 32.8565 23.9293 32.9327C23.9479 33.1422 23.9792 33.2182 24.0006 33.2562C24.0605 33.3623 24.1465 33.4504 24.2502 33.5116C24.2873 33.5335 24.3616 33.5656 24.5663 33.5845C24.7804 33.6044 25.0628 33.6051 25.5002 33.6051C25.9376 33.6051 26.22 33.6044 26.4341 33.5845C26.6387 33.5656 26.713 33.5335 26.7502 33.5116C26.8538 33.4504 26.9399 33.3623 26.9997 33.2562C27.0212 33.2182 27.0525 33.1422 27.071 32.9327C27.0778 32.8565 27.0823 32.7718 27.0852 32.6748Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6106 21.1769C26.9171 21.4008 26.988 21.8366 26.7692 22.1501L25.5912 23.8376H26.9936C27.249 23.8376 27.483 23.9837 27.5998 24.2161C27.7167 24.4484 27.6968 24.7282 27.5484 24.9408L25.6003 27.7315C25.3815 28.0451 24.9556 28.1177 24.6492 27.8937C24.3428 27.6698 24.2718 27.234 24.4907 26.9205L25.6687 25.233H24.2663C24.0109 25.233 23.7769 25.0869 23.66 24.8545C23.5432 24.6222 23.563 24.3424 23.7115 24.1298L25.6595 21.3391C25.8784 21.0255 26.3042 20.9529 26.6106 21.1769Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3348_15986",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3348_15986"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3348_15986",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedSix);
export default __webpack_public_path__ + "static/media/Featured_six.0404f367c9dae6cddecd71546208afaf.svg";
export { ForwardRef as ReactComponent };